import "../pages/LoginPage.css";
import React, { useState, useEffect } from "react";
import img from "../component/Images/login .png";
import logo from "../component/Images/gore logo (1).jpg";
import introVideo from "../component/Images/Gore Video.mp4";
import SignupPage from "./SignupPage.jsx";
import apiService from "../services/apiService";
const getApiErrorMessage = (
    error,
    fallback
) => {
    const data =
        error?.response?.data;
    if (
        typeof data === "string" &&
        data.trim()
    ) {
        return data;
    }

    if (
        data &&
        typeof data === "object"
    ) {
        if (
            data?.errors &&
            typeof data.errors === "object"
        ) {
            const validationErrors =
                Object.entries(data.errors)
                    .flatMap(
                        ([key, value]) => {
                            const messages =
                                Array.isArray(value)
                                    ? value
                                    : [value];
                            return messages.map(
                                (message) =>
                                    `${key}: ${message}`
                            );
                        }
                    )
                    .filter(Boolean)
                    .join(" ");
            if (validationErrors) {

                return validationErrors;

            }

        }



        return (

            data?.failureReason ||

            data?.FailureReason ||

            data?.message ||

            data?.Message ||

            data?.title ||

            data?.error ||

            error?.message ||

            fallback

        );

    }



    return (

        error?.message ||

        fallback

    );

};





export default function LoginPage({ onLogin, onRegister }) {



    const [successMessage, setSuccessMessage] = useState("");



    const [showPassword, setShowPassword] = useState(false);

    const [showIntroVideo, setShowIntroVideo] = useState(false);
    const [videoProgress, setVideoProgress] = useState(0);

    const [showSignup, setShowSignup] = useState(false);



    const [showNewPassword, setShowNewPassword] = useState(false);



    const [showConfirmPassword, setShowConfirmPassword] = useState(false);



    const [showForgotPassword, setShowForgotPassword] = useState(false);



    const [showVerification, setShowVerification] = useState(false);



    const [showResetPassword, setShowResetPassword] = useState(false);



    const [showSuccess, setShowSuccess] = useState(false);



    const [forgotEmail, setForgotEmail] = useState("");



    const [otp, setOtp] = useState(["", "", "", "", "", ""]);



    const [newPassword, setNewPassword] = useState("");



    const [confirmPassword, setConfirmPassword] = useState("");



    const [timeLeft, setTimeLeft] = useState(30);



    const [email, setEmail] = useState("");



    const [password, setPassword] = useState("");



    const [loading, setLoading] = useState(false);



    const [error, setError] = useState("");











    const handleLogin = async () => {

        setError("");



        if (!email || !password) {

            setError("Email and Password are required");

            return;

        }



        try {

            setLoading(true);



            const apiPayload = {

                UserName: email,

                Password: password

            };



            console.log("Login Request:", apiPayload);



            const response =

                await apiService.post(

                    "User/authenticate",

                    apiPayload

                );



            const result =

                response?.data;



            console.log(

                "Full Login Response:",

                result

            );



            if (

                result?.isSuccess === false ||

                result?.IsSuccess === false

            ) {

                throw new Error(

                    result?.failureReason ||

                    result?.FailureReason ||

                    result?.message ||

                    result?.Message ||

                    "Login failed. Email or Password Check."

                );

            }



            const userData =

                result?.output ??

                result?.Output ??

                result?.data ??

                result?.Data ??

                result;



            if (

                !userData ||

                typeof userData !== "object"

            ) {

                throw new Error(

                    "User data not received from login API."

                );

            }



            console.log(

                "LOGIN USER KEYS:",

                Object.keys(userData)

            );



            console.log(

                "TeacherId:",

                userData?.teacherId ??

                userData?.TeacherId

            );



            const token =

                userData?.token ??

                userData?.Token ??

                result?.token ??

                result?.Token ??

                "";



            if (!token) {

                throw new Error(

                    "Token not received from login API."

                );

            }



            const userId =

                userData?.id ??

                userData?.Id ??

                userData?.userId ??

                userData?.UserId ??

                result?.id ??

                result?.Id ??

                result?.userId ??

                result?.UserId;



            const teacherId =

                userData?.teacherId ??

                userData?.TeacherId ??

                result?.teacherId ??

                result?.TeacherId;



            console.log(

                "Login User ID:",

                userId

            );



            console.log(

                "Login Teacher ID:",

                teacherId

            );



            if (

                userId === undefined ||

                userId === null ||

                userId === ""

            ) {

                console.error(

                    "Login API response does not contain user id:",

                    result

                );



                throw new Error(

                    "User ID not received from login API."

                );

            }



            const firstName =

                userData?.firstName ??

                userData?.FirstName ??

                "";



            const middleName =

                userData?.middleName ??

                userData?.MiddleName ??

                "";



            const lastName =

                userData?.lastName ??

                userData?.LastName ??

                "";



            const role =

                userData?.role ??

                userData?.Role ??

                "";



            const roleIds =

                userData?.roleIds ??

                userData?.RoleIds ??

                "";



            const fullName =

                userData?.fullName ??

                userData?.FullName ??

                [firstName, middleName, lastName]

                    .filter(Boolean)

                    .join(" ");



            sessionStorage.setItem(

                "user",

                JSON.stringify(userData)

            );



            sessionStorage.setItem(

                "userId",

                String(userId)

            );



            if (

                teacherId !== undefined &&

                teacherId !== null &&

                teacherId !== ""

            ) {

                sessionStorage.setItem(

                    "teacherId",

                    String(teacherId)

                );

            } else {

                sessionStorage.removeItem(

                    "teacherId"

                );

            }



            sessionStorage.setItem(

                "isLoggedIn",

                "true"

            );



            sessionStorage.setItem(

                "email",

                userData?.email ??

                userData?.Email ??

                email

            );



            sessionStorage.setItem(

                "token",

                token

            );



            sessionStorage.setItem(

                "fullName",

                fullName

            );



            sessionStorage.setItem(

                "role",

                String(role)

            );



            sessionStorage.setItem(

                "roleIds",

                String(roleIds)

            );



            console.log(

                "Saved User ID:",

                sessionStorage.getItem("userId")

            );



            console.log(

                "Saved User:",

                JSON.parse(

                    sessionStorage.getItem("user")

                )

            );



            setSuccessMessage("");
            setShowIntroVideo(true);



        } catch (err) {

            console.error(

                "Login API Error:",

                err

            );



            setError(

                getApiErrorMessage(

                    err,

                    "Login failed. Email or Password Check."

                )

            );



        } finally {

            setLoading(false);

        }

    };





    const handleForgotPassword = async () => {

        setError("");



        if (!forgotEmail) {

            setError("Email is required");

            return;

        }



        try {

            setLoading(true);



            const response =

                await apiService.get(

                    `ChangePassword/emailVerifiedForPassword?email=${encodeURIComponent(

                        forgotEmail

                    )}`

                );



            const result =

                response?.data;



            console.log(

                "Forgot Password Response:",

                result

            );



            if (

                result?.isSuccess === false ||

                result?.IsSuccess === false

            ) {

                throw new Error(

                    result?.failureReason ||

                    result?.FailureReason ||

                    result?.message ||

                    result?.Message ||

                    "Failed to send OTP."

                );

            }



            setShowVerification(true);



        } catch (err) {

            console.error(

                "Forgot Password API Error:",

                err

            );



            setError(

                getApiErrorMessage(

                    err,

                    "Failed to send OTP."

                )

            );



        } finally {

            setLoading(false);

        }

    };





    const handleResetPassword = async () => {

        setError("");



        const otpCode =

            otp.join("");



        if (otpCode.length !== 6) {

            setError(

                "Please enter 6 digit OTP"

            );

            return;

        }



        if (

            !newPassword ||

            !confirmPassword

        ) {

            setError(

                "Password and Confirm Password are required"

            );

            return;

        }



        if (

            newPassword !==

            confirmPassword

        ) {

            setError(

                "Passwords do not match"

            );

            return;

        }



        try {

            setLoading(true);



            const apiPayload = {

                Email: forgotEmail,

                OTP: Number(otpCode),

                NewPassword: newPassword,

                Hash: "frontend-not-used",

                Salt: "frontend-not-used"

            };



            console.log(

                "Reset Password Request:",

                apiPayload

            );



            const response =

                await apiService.post(

                    "ChangePassword/resetPassword",

                    apiPayload

                );



            const result =

                response?.data;



            console.log(

                "Reset Password Response:",

                result

            );



            if (

                result?.isSuccess === false ||

                result?.IsSuccess === false

            ) {

                throw new Error(

                    result?.failureReason ||

                    result?.FailureReason ||

                    result?.message ||

                    result?.Message ||

                    "Reset password failed."

                );

            }



            setShowSuccess(true);



        } catch (err) {

            console.error(

                "Reset Password API Error:",

                err

            );



            setError(

                getApiErrorMessage(

                    err,

                    "Reset password failed."

                )

            );



        } finally {

            setLoading(false);

        }

    };





    useEffect(() => {



        if (!showVerification || showResetPassword) return;







        setTimeLeft(30);







        const timer = setInterval(() => {



            setTimeLeft((prev) => {



                if (prev <= 1) {



                    clearInterval(timer);



                    return 0;



                }



                return prev - 1;



            });



        }, 1000);







        return () => clearInterval(timer);



    }, [showVerification, showResetPassword]);







    if (showSignup) {



        return (



            <SignupPage



                onBackToLogin={() => setShowSignup(false)}



            />



        );



    }



    const ErrorMessage = () =>



        error ? (



            <p



                style={{



                    color: "red",



                    marginTop: "8px",



                    marginBottom: "10px",



                    fontSize: "14px",



                }}



            >



                {error}



            </p>



        ) : null;

    if (showIntroVideo) {
        return (
            <div
                style={{
                    position: "fixed",
                    inset: 0,
                    width: "100vw",
                    height: "100dvh",
                    background: "#000",
                    zIndex: 99999,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                }}
            >
                <video
                    src={introVideo}
                    autoPlay
                    playsInline
                    onTimeUpdate={(e) => {
                        const video = e.currentTarget;

                        if (video.duration) {
                            const progress =
                                (video.currentTime / video.duration) * 100;

                            setVideoProgress(progress);
                        }
                    }}
                    onEnded={() => {
                        setVideoProgress(100);
                        setShowIntroVideo(false);
                        onLogin();
                    }}
                    style={{
                        width: "100%",
                        height: "100%",
                        maxWidth: "100vw",
                        maxHeight: "100dvh",
                        objectFit: "contain",
                        display: "block",
                        background: "#000",
                    }}
                />

                {/* VIDEO PROGRESS BAR */}
                <div
                    style={{
                        position: "absolute",
                        bottom: "20px",
                        left: "5%",
                        width: "90%",
                        height: "5px",
                        background: "rgba(255,255,255,0.25)",
                        borderRadius: "20px",
                        overflow: "hidden",
                    }}
                >
                    <div
                        style={{
                            width: `${videoProgress}%`,
                            height: "100%",
                            background: "#ffffff",
                            borderRadius: "20px",
                            transition: "width 0.15s linear",
                        }}
                    />
                </div>
            </div>
        );
    }   





    return (



        <div className="login-container">



            <div className="login-left">



                <img src={img} alt="Login Illustration" className="login-image" />



            </div>







            <div className="login-right">



                <div className="login-box">



                    <div className="logo">



                        <img src={logo} alt="Logo" className="logo-img" />



                    </div>



                    {successMessage && (



                        <div



                            style={{



                                backgroundColor: "#d1e7dd",



                                color: "#0f5132",



                                border: "1px solid #badbcc",



                                padding: "10px 14px",



                                borderRadius: "6px",



                                marginBottom: "15px",



                                fontSize: "14px",



                                fontWeight: "500",



                            }}



                        >



                            ✓ {successMessage}



                        </div>



                    )}







                    {!showForgotPassword ? (



                        <>



                            <h1>Log in to your account</h1>



                            <p>Welcome back! Please enter your details.</p>







                            {error && (



                                <p style={{ color: "red", marginBottom: "10px" }}>



                                    {error}



                                </p>



                            )}







                            <div className="form-group">



                                <label>Email/UserName*</label>



                                <input



                                    type="email"



                                    placeholder="Enter your email"



                                    value={email}



                                    onChange={(e) => setEmail(e.target.value)}



                                />



                            </div>







                            <div className="form-group">



                                <label>Password*</label>



                                <div className="password-box">



                                    <input



                                        type={showPassword ? "text" : "password"}



                                        placeholder="Enter password"



                                        value={password}



                                        onChange={(e) => setPassword(e.target.value)}



                                    />







                                    <span

                                        className={`eye ${showPassword ? "open" : "closed"}`}

                                        onClick={() => setShowPassword((prev) => !prev)}

                                        title={showPassword ? "Hide password" : "Show password"}

                                    >

                                        <span className="eye-icon">👁</span>

                                    </span>



                                </div>



                            </div>







                            <div className="login-options">



                                <button



                                    type="button"



                                    className="forgot-link"



                                    onClick={() => setShowForgotPassword(true)}



                                >



                                    Forgot Password?



                                </button>



                            </div>







                            <div className="login-action-row">
                            <button
                                className="signin-btn"
                                onClick={handleLogin}
                                disabled={loading}
                            >
                                {loading ? "Logining In..." : "Log-In"}
                            </button>

                            <div className="register-section">
                                <div className="register-divider">
                                    <span>or</span>
                                </div>
                                <button
                                    type="button"
                                    className="register-btn"
                                    onClick={onRegister}
                                >
                                    Register Now As Student
                                </button>
                            </div>
                            </div>
                        </>



                    ) : !showVerification ? (



                        <>



                            <h1>Forgot Password</h1>







                            <p>



                                Enter your email for the verification process,



                                we will send a 6



                                digit code to your email.



                            </p>







                            <div className="form-group">



                                <label>Email/UserName*</label>



                                <input



                                    type="email"



                                    placeholder="Enter your email"



                                    value={forgotEmail}



                                    onChange={(e) => setForgotEmail(e.target.value)}



                                />



                            </div>



                            <ErrorMessage />







                            <button



                                className="signin-btn"



                                onClick={handleForgotPassword}



                                disabled={loading}



                            >



                                {loading ? "Sending OTP..." : "Continue"}



                            </button>







                            <div className="signup-text">



                                <button



                                    className="back-link"



                                    onClick={() => setShowForgotPassword(false)}



                                >



                                    ← Back to Login



                                </button>



                            </div>



                        </>



                    ) : !showResetPassword ? (



                        <>



                            <h1>Verification</h1>







                            <p>



                                Enter your 6-digit verification code sent to your email address.



                            </p>







                            <div className="otp-container">



                                {otp.map((digit, index) => (



                                    <input



                                        key={index}



                                        type="text"



                                        maxLength="1"



                                        className="otp-input"



                                        value={digit}



                                        onChange={(e) => {



                                            const value = e.target.value.replace(/\D/g, "");







                                            const newOtp = [...otp];



                                            newOtp[index] = value;



                                            setOtp(newOtp);







                                            if (value && e.target.nextSibling) {



                                                e.target.nextSibling.focus();



                                            }



                                        }}



                                    />



                                ))}



                            </div>







                            <div className="otp-timer">



                                00:{String(timeLeft).padStart(2, "0")}



                            </div>







                            <button



                                className="signin-btn"



                                onClick={() => {



                                    setError("");







                                    const otpCode = otp.join("");







                                    if (otpCode.length !== 6) {



                                        setError("Please enter the complete 6-digit OTP.");



                                        return;



                                    }







                                    setShowResetPassword(true);



                                }}



                            >



                                Continue



                            </button>







                            <ErrorMessage />







                            <div className="signup-text">



                                <button



                                    className="back-link"



                                    onClick={() => setShowForgotPassword(false)}



                                >



                                    ← Back to Login



                                </button>



                            </div>







                            <div className="signup-text">



                                If you didn't receive a code?



                                <button



                                    className="resend-link"



                                    disabled={timeLeft > 0}



                                    onClick={handleForgotPassword}



                                >



                                    Resend



                                </button>



                            </div>



                        </>



                    ) : !showSuccess ? (



                        <>



                            <h1>New Password</h1>







                            <p>



                                Set the new password for your account so you can login and



                                access all features.



                            </p>







                            <div className="form-group">



                                <label>New Password*</label>







                                <div className="password-box">



                                    <input



                                        type={showNewPassword ? "text" : "password"}



                                        placeholder="6 symbols at least"



                                        value={newPassword}



                                        onChange={(e) => setNewPassword(e.target.value)}



                                    />







                                    <span

                                        className={`eye ${showNewPassword ? "open" : "closed"}`}

                                        onClick={() => setShowNewPassword((prev) => !prev)}

                                        title={showNewPassword ? "Hide password" : "Show password"}

                                    >

                                        <span className="eye-icon">👁</span>

                                    </span>



                                </div>



                            </div>







                            <div className="form-group">



                                <label>Confirm Password*</label>







                                <div className="password-box">



                                    <input



                                        type={showConfirmPassword ? "text" : "password"}



                                        placeholder="6 symbols at least"



                                        value={confirmPassword}



                                        onChange={(e) => {



                                            setConfirmPassword(e.target.value);



                                            setError("");



                                        }}



                                    />







                                    <span

                                        className={`eye ${showConfirmPassword ? "open" : "closed"}`}

                                        onClick={() => setShowConfirmPassword((prev) => !prev)}

                                        title={showConfirmPassword ? "Hide password" : "Show password"}

                                    >

                                        <span className="eye-icon">👁</span>

                                    </span>



                                </div>



                            </div>







                            <ErrorMessage />







                            <button



                                className="signin-btn"



                                onClick={handleResetPassword}



                                disabled={loading}



                            >



                                {loading ? "Updating..." : "Update Password"}



                            </button>







                            <div className="signup-text">



                                <button



                                    className="back-link"



                                    onClick={() => setShowForgotPassword(false)}



                                >



                                    ← Back to Login



                                </button>



                            </div>



                        </>



                    ) : (



                        <>



                            <div className="success-icon">✓</div>







                            <h1>Successfully</h1>







                            <p>Your password has been reset successfully</p>







                            <button



                                className="signin-btn"



                                onClick={() => {



                                    setShowForgotPassword(false);



                                    setShowVerification(false);



                                    setShowResetPassword(false);



                                    setShowSuccess(false);







                                    setOtp(["", "", "", "", "", ""]);



                                    setNewPassword("");



                                    setConfirmPassword("");



                                    setError("");







                                    setEmail(forgotEmail);



                                    setPassword("");



                                }}



                            >



                                Continue



                            </button>



                        </>



                    )}



                </div>



            </div>



        </div>



    );



}